import React__default from 'react';
import classNames from '../../../node_modules/classnames/index.esm.js';

const ProposalListItem = ({
  data,
  onClick,
  active
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('proposal-item', {
      'active': active
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "font-semibold"
  }, data.name), /*#__PURE__*/React__default.createElement("button", {
    className: "add-btn",
    onClick: () => onClick(data.id)
  }, /*#__PURE__*/React__default.createElement("i", {
    className: active ? 'ri-check-line text-white' : 'ri-add-line'
  })));
};

export { ProposalListItem as default };
//# sourceMappingURL=ProposalListItem.esm.js.map
